import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import Popup from "reactjs-popup";
import { declineTender } from "../services/sharedTendersService";
import articlesCalc from "../services/articlesCalcService";
import { CostEstimateRowsCalculator } from "../services/costEstimateRowsService";
import { saveTenderAsPdf } from "../services/createPdfService";

class StandardTender extends Component {
    popupStyle = {
        background: "transparent none",
        border: "none",
        borderRadius: "4px",
        padding: "0"
    };

    handleAcceptTender = event => {
        event.preventDefault();
        const {
            contactEmail,
            contactName,
            note,
            purchaseNumber,
            quantity
        } = this.state;
        const data = {
            contactEmail,
            contactName,
            note,
            purchaseNumber,
            quantity
        };
    };

    handleChangeDeclineReason = event => {
        const declineReason = event.target.value;
        this.setState({
            declineReason
        });
    };

    handleChangeApproveTerms = event => {
        this.setState({
            approveTerms: event.target.checked
        });
    };

    handleChangeQuantity = event => {
        this.setState({
            quantity: event.target.value
        });
    };

    handleDeclineTender = event => {
        event.preventDefault();
        const { hash } = this.props;
        const message = this.declineReasonTextInput.current.value;
        declineTender(hash, message);
    };

    handleTextInputChange = (name, event) => {
        event.preventDefault();
        this.setState({
            [name]: event.target.value
        });
    };

    handleClickAccept = event => {
        event.preventDefault();
        this.setState({
            openAcceptPopup: true,
            openDeclinePopup: false,
            openMessagePopup: false
        });
    };

    handleClickPrint = event => {
        const productInfoTable = document.getElementById('tenderRows').getElementsByTagName('table')[0].outerHTML;
        saveTenderAsPdf(this.props.hash, productInfoTable, 'Offert_' + this.props.costEstimateNumber + '.pdf');
        event.preventDefault();
    };

    handleClickDecline = event => {
        event.preventDefault();
        this.setState({
            openAcceptPopup: false,
            openDeclinePopup: true,
            openMessagePopup: false
        });
    };

    handleClickMessage = event => {
        event.preventDefault();
        this.setState({
            openAcceptPopup: false,
            openDeclinePopup: false,
            openMessagePopup: true
        });
    };

    handleClosedPopup = name => {
        this.setState({
            [name]: false
        });
    };

    constructor(props) {
        super(props);

        let { contact } = props;
        const approveTerms = false;
        const contactEmail = contact.email;
        const contactName = contact.firstname + " " + contact.lastname;
        const declineReason = 0;
        const note = "";
        const openAcceptPopup = false;
        const openDeclinePopup = false;
        const openMessagePopup = false;
        const purchaseNumber = "";
        const quantity = null;

        this.declineReasonTextInput = React.createRef();
        this.acceptTenderIFrame = React.createRef();
        this.declineTenderIFrame = React.createRef();
        this.messageIFrame = React.createRef();

        this.state = {
            approveTerms,
            contactEmail,
            contactName,
            declineReason,
            note,
            openAcceptPopup,
            openDeclinePopup,
            openMessagePopup,
            purchaseNumber,
            quantity,
            multipler: this.props.quantities[0]
        };
    }

    componentDidMount() { }

    renderActions() {
        const { customerAcceptedDate, customerRejectedDate } = this.props;
        let buttons = null;

        if (customerAcceptedDate || customerRejectedDate) {
            buttons = (
                <Fragment>
                    <button
                        className="btn btn-icon btn-icon--message"
                        onClick={event => this.handleClickMessage(event)}
                    >Meddela</button>
                    <button
                        className="btn btn-icon btn-icon--tender ml-4 js-createPdfClickReceiver"
                        onClick={event => this.handleClickPrint(event)}
                    >Skriv ut</button>
                </Fragment>
            );
        } else {
            buttons = (
                <Fragment>
                    <button
                        className="btn btn-icon btn-icon--decline btn-danger"
                        onClick={event => this.handleClickDecline(event)}
                    >
                        Avböj
                    </button>
                    <button
                        className="btn btn-icon btn-icon--message ml-4"
                        onClick={event => this.handleClickMessage(event)}
                    >
                        Meddela
                    </button>
                    <button
                        className="btn btn-icon btn-icon--tender ml-4 js-createPdfClickReceiver"
                        onClick={event => this.handleClickPrint(event)}
                    >
                        Skriv ut
                    </button>
                    <button
                        className="btn btn-icon btn-icon--order ml-4 btn-success"
                        onClick={event => this.handleClickAccept(event)}
                    >
                        Beställ
                    </button>
                </Fragment>
            );
        }

        return (
            <div className="row">
                <div className="col text-right">{buttons}</div>
            </div>
        );
    }

    getWeight(row) {
        const props = [];
        if (row) {
            props.rows = [row];
        } else {
            props.rows = this.props.rows;
        }

        props.multiplier = this.props.quantities[0];

        return CostEstimateRowsCalculator.getTotalWeight(props);
    }

    getUnitPrice(row) {
        const props = [];
        if (row) {
            props.rows = [row];
        } else {
            props.rows = this.props.rows;
        }

        if (row && row.is_single) {
            props.multiplier = 1;
        } else {
            props.multiplier = this.props.quantities[0];
        }

        return Number(
            CostEstimateRowsCalculator.getTotalUnitPrice(props)
        ).toSek();
    }

    getTotalPrice(row) {
        const props = [];
        if (row) {
            props.rows = [row];
        } else {
            props.rows = this.props.rows;
        }

        props.multiplier = this.props.quantities[0];

        return Number(CostEstimateRowsCalculator.getTotalPrice(props)).toSek();
    }

    getDiscount(row) {
        const props = [];
        if (row) {
            props.rows = [row];
        } else {
            props.rows = this.props.rows;
        }

        if (row && row.is_single) {
            props.multiplier = 1;
        } else {
            props.multiplier = this.props.quantities[0];
        }

        return Number(CostEstimateRowsCalculator.getTotalDiscount(props)) + "%";
    }

    getUnitPriceAfterDiscount(row) {
        const props = [];
        if (row) {
            props.rows = [row];
        } else {
            props.rows = this.props.rows;
        }

        if (row && row.is_single) {
            props.multiplier = 1;
        } else {
            props.multiplier = this.props.quantities[0];
        }

        return Number(
            CostEstimateRowsCalculator.getTotalUnitPriceAfterDiscount(props)
        ).toSek();
    }

    getTotalPriceAfterDiscount(row) {
        const props = [];
        if (row) {
            props.rows = [row];
        } else {
            props.rows = this.props.rows;
        }

        props.multiplier = this.props.quantities[0];

        return Number(
            CostEstimateRowsCalculator.getTotalPriceAfterDiscount(props)
        ).toSek();
    }

    render() {
        const {
            acceptTenderIFrameSrc,
            declineTenderIFrameSrc,
            messageTenderIFrameSrc,
            rows
        } = this.props;
        const {
            openAcceptPopup,
            openDeclinePopup,
            openMessagePopup
        } = this.state;

        const acceptIframeContentsHeight = 925;
        const acceptTenderDialogueHeight = window.innerHeight < acceptIframeContentsHeight + 100 ? window.innerHeight - 200 : acceptIframeContentsHeight-200;

        return (
            <Fragment>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th key={0}>Produkt</th>
                            <th key={1} className="text-right">
                                Antal
                            </th>
                            <th key={2} className="text-right">
                                Vikt i kg
                            </th>
                            <th key={3} className="text-right">
                                Pris/st
                            </th>
                            <th key={4} className="text-right">
                                Pris
                            </th>
                            {(CostEstimateRowsCalculator.hasAnyDiscount(this.props)) && (
                                <Fragment>
                                    <th key={5} className="text-right">
                                        Rabatt
                                    </th>
                                    <th key={6} className="text-right">
                                        Pris/st
                                    </th>
                                    <th key={7} className="text-right">
                                        Slutpris
                                    </th>
                                </Fragment>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {
                        rows.map((row, rowIndex) => {
                            if (row.quantity == 0) return;

                            const rowQuantity = row.is_single ? row.quantity : row.quantity * this.props.quantities[0];

                            return (
                                <tr key={rowIndex}>
                                    <td key={0}>{row.name}</td>
                                    <td key={1} className="text-right">
                                    {parseFloat(parseFloat(rowQuantity).toFixed(4))}
                                    </td>
                                    <td key={2} className="text-right">
                                        {this.getWeight(row)}
                                    </td>
                                    <td key={3} className="text-right">
                                        {this.getUnitPrice(row)}
                                    </td>
                                    <td key={4} className="text-right">
                                        {this.getTotalPrice(row)}
                                    </td>
                                    {(CostEstimateRowsCalculator.hasAnyDiscount(this.props)) && (
                                        <Fragment>
                                            <td key={5} className="text-right">
                                                {this.getDiscount(row)}
                                            </td>
                                            <td key={6} className="text-right">
                                                {this.getUnitPriceAfterDiscount(
                                                    row
                                                )}
                                            </td>
                                            <td key={7} className="text-right">
                                                {this.getTotalPriceAfterDiscount(
                                                    row
                                                )}
                                            </td>
                                        </Fragment>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot className="font-weight-bold">
                        <tr key={99}>
                            <td key={0}>Summa</td>
                            <td key={1} className="text-right">
                                &nbsp;
                            </td>
                            <td key={2} className="text-right">
                                {this.getWeight()}
                            </td>
                            <td key={3} className="text-right">
                                {this.getUnitPrice()}
                            </td>
                            <td key={4} className="text-right">
                                {this.getTotalPrice()}
                            </td>
                            {(CostEstimateRowsCalculator.hasAnyDiscount(this.props)) && (
                                <Fragment>
                                    <td key={5} className="text-right">
                                        {this.getDiscount()}
                                    </td>
                                    <td key={6} className="text-right">
                                        {this.getUnitPriceAfterDiscount()}
                                    </td>
                                    <td key={7} className="text-right">
                                        {this.getTotalPriceAfterDiscount()}
                                    </td>
                                </Fragment>
                            )}
                        </tr>
                    </tfoot>
                </table>
                {this.renderActions()}
                <Popup
                    closeOnDocumentClick
                    contentStyle={this.popupStyle}
                    modal
                    onClose={() => this.handleClosedPopup("openAcceptPopup")}
                    open={openAcceptPopup}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Beställ
                            </header>
                            <div className="content p-0 hideVerticalScrollbar">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height={acceptTenderDialogueHeight}
                                        ref={this.acceptTenderIFrame}
                                        src={acceptTenderIFrameSrc}
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
                <Popup
                    closeOnDocumentClick
                    contentStyle={this.popupStyle}
                    modal
                    onClose={() => this.handleClosedPopup("openDeclinePopup")}
                    open={openDeclinePopup}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Avböjer offerten
                            </header>
                            <div className="content p-0">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height="400"
                                        ref={this.declineTenderIFrame}
                                        src={declineTenderIFrameSrc}
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
                <Popup
                    closeOnDocumentClick
                    contentStyle={this.popupStyle}
                    modal
                    onClose={() => this.handleClosedPopup("openMessagePopup")}
                    open={openMessagePopup}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Meddela säljaren
                            </header>
                            <div className="content p-0">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height="400"
                                        ref={this.messageTenderIFrameSrc}
                                        src={messageTenderIFrameSrc}
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
            </Fragment>
        );
    }
}

if (window.standardTenderSettings) {

    const t = window.standardTenderSettings;
    ReactDOM.render(
        <StandardTender
            acceptTenderIFrameSrc={t.data.acceptTenderIFrameSrc}
            contact={t.data.contact}
            costEstimateId={t.data.costEstimateId}
            costEstimateNumber={t.data.costEstimateNumber}
            customerAcceptedDate={t.data.customerAcceptedDate}
            customerRejectedDate={t.data.customerRejectedDate}
            date={t.data.date}
            declineTenderIFrameSrc={t.data.declineTenderIFrameSrc}
            messageTenderIFrameSrc={t.data.messageTenderIFrameSrc}
            deliveryDays={t.data.deliveryDays}
            hash={t.data.hash}
            name={t.data.name}
            quantities={t.data.quantities}
            customer={t.data.customer}
            rows={t.data.rows}
        />,
        t.settings.target
    );
}
